import { GPS_STRATEGIES } from '@careerstart/wae-common/schema/models/position-template/enums/gpsStrategies';

import { DEFAULT_MAX_PUNCH_DISTANCE } from '../constants';

const RATE_FIELDS = [
  ['Reg', 'reg'],
  ['OT', 'ot'],
  ['DT', 'dt'],
];

const toRateFields = (prefix, rates) =>
  RATE_FIELDS.reduce((fields, [suffix, key]) => {
    const rate = Number.parseFloat(rates?.[key]);
    return Number.isNaN(rate) ? fields : { ...fields, [`${prefix}${suffix}`]: rate };
  }, {});

const toIds = (documents) => (documents || []).map((document) => document._id);

const buildCreatePositionTemplateV2Payload = (values) => {
  const { additionalInfo = {}, legalInfo = {}, requirements = {} } = values;

  return {
    fields: {
      corporation: values.corporation?._id,
      name: values.name?.trim(),
      description: values.description?.trim(),
      industry: values.industry,
      locationAndWorkersCompPairings: (values.locations || []).map((location) => ({
        locationId: location.id,
        workersCompCode: location.compCode,
      })),
      ...toRateFields('payRate', values.payRates),
      ...toRateFields('billRate', values.billRates),
      shifts: (values.shifts || []).map(({ name, start, end }) => ({
        name: name?.trim(),
        start,
        end,
      })),
      certifications: toIds(requirements.certifications),
      skills: toIds(requirements.skills),
      requireEmployerApproval: !!additionalInfo.requireEmployerApproval,
      allowBackfill: !!additionalInfo.allowBackfill,
      overtimeAllowed: !!additionalInfo.overtimeAllowed,
      flags: {
        isEnforcingAttendancePolicy: !!additionalInfo.isEnforcingAttendancePolicy,
        isPunchingOutsideOfShiftEnabled: !!additionalInfo.isPunchingOutsideOfShiftEnabled,
        ...(typeof additionalInfo.isEarlyAccessAvailableJobsWindowEnabled === 'boolean' && {
          isEarlyAccessAvailableJobsWindowEnabled:
            additionalInfo.isEarlyAccessAvailableJobsWindowEnabled,
        }),
      },
      gps: {
        strategy: additionalInfo.isGPSEnforced
          ? GPS_STRATEGIES.ENFORCED
          : GPS_STRATEGIES.UNENFORCED,
        maxDistance:
          Number.parseInt(additionalInfo.punchDistance, 10) || DEFAULT_MAX_PUNCH_DISTANCE,
      },
      timekeeping: {
        breaks: { paid: { behavior: legalInfo.paidBreakBehavior } },
        punches: {
          rounding: { amount: additionalInfo.punchRounding },
          window: { inEarly: additionalInfo.earlyPunchWindow },
        },
      },
    },
  };
};

export default buildCreatePositionTemplateV2Payload;
